let unloading = false

const markUnloading = () => {
  unloading = true
}

// A bfcache restore reuses the same document, so the flag has to clear again.
const markLoaded = () => {
  unloading = false
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', markUnloading)
  window.addEventListener('pagehide', markUnloading)
  window.addEventListener('pageshow', markLoaded)
}

// A refresh or a navigation cancels every in-flight fetch, which rejects with a network TypeError
// that is not a real failure. Callers use this to tell that case from a genuinely broken request.
export const isPageUnloading = () => unloading
